// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/element-custom.css";
Vue.use(ElementUI);
Vue.use(ElementUI, {
  $message: {
    type: 'error'
  }
})
import App from "./App";
import router from "./router";
import store from "./store";
import api from "../common/api.js";
Vue.prototype.api = api;

import smCom from "../common/global/smCom.js";
Vue.prototype.fGetSmMenuQx = smCom.fGetSmMenuQx;

import fLng from "./assets/lng/lng.js";
Vue.prototype.fLng = fLng;

import "./assets/css/reset.css";
import "./assets/css/global.css";
import "./assets/fonts/iconfont.css";

// import VxeUIAll from 'vxe-pc-ui'
// import 'vxe-pc-ui/lib/style.css'
// Vue.use(VxeUIAll)
import VxeUIAll from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'

// VxeUITable.setConfig({
//     table: {
//         header: {
//             cellStyle: {
//                 color: 'red' // 红色字体
//             }
//         }
//     }
// })
VxeUITable.config({
    /** 全局尺寸 */
    size: "mini",
})

// ...
import { VxeUI } from 'vxe-pc-ui';
import XEUtils from 'xe-utils';
Vue.prototype.XEUtils = XEUtils;
// 式化日期，默认 yyyy-MM-dd HH:mm:ss
VxeUI.formats.add('formatDate', {
    tableCellFormatMethod({ cellValue }, format) {
        return XEUtils.toDateString(cellValue, format || 'yyyy-MM-dd HH:mm:ss');
    }
});
// 四舍五入金额，每隔3位逗号分隔，默认2位数
VxeUI.formats.add('formatAmount', {
    tableCellFormatMethod({ cellValue }, digits = 2) {
        return api.numHelper.fMoneyFat(cellValue, digits); //金额格式化
        // return XEUtils.commafy(XEUtils.toNumber(cellValue), { digits });
    },
    tableFooterCellFormatMethod({ itemValue }, digits = 2) {
        // return XEUtils.commafy(XEUtils.toNumber(itemValue), { digits });
    }

});
// 向下舍入,默认两位数
VxeUI.formats.add('formatCutNumber', {
    tableCellFormatMethod({ cellValue }, digits = 2) {
        return XEUtils.toFixed(XEUtils.floor(cellValue, digits), digits);
    },
    tableFooterCellFormatMethod({ itemValue }, digits = 2) {
        return XEUtils.toFixed(XEUtils.floor(itemValue, digits), digits);
    }
});
// 四舍五入,默认两位数
VxeUI.formats.add('formatFixedNumber', {
    tableCellFormatMethod({ cellValue }, digits = 2) {
        return XEUtils.toFixed(XEUtils.round(cellValue, digits), digits);
    },
    tableFooterCellFormatMethod({ itemValue }, digits = 2) {
        return XEUtils.toFixed(XEUtils.round(itemValue, digits), digits);
    }
});


Vue.use(VxeUIAll)
Vue.use(VxeUITable)
// 封装组件
import timeChang from "./components/timeChang.vue";
Vue.component("timeChang", timeChang);
// 封装命名组件
// import Tree from "./components/Tree.vue";
// Vue.component("Tree", Tree);
import AsyncSelect from "./components/x-select-filter.vue";
Vue.component("AsyncSelect", AsyncSelect);
// 图形验证
import SlideVerify from "vue-monoplasty-slide-verify";
Vue.use(SlideVerify);

import xPopup from "./components/x-popup.vue";
Vue.component("xPopup", xPopup);
import xButton from "./components/xButton.vue";
Vue.component("xButton", xButton);
import xSelectTree from "./components/x-select-tree.vue";
Vue.component("xSelectTree", xSelectTree);
import clsManage from "./components/cls_manage.vue";
Vue.component("clsManage", clsManage);

import xNumberInp from "./components/xNumberInp.vue";
Vue.component("xNumberInp", xNumberInp);
import importExcel from "./components/importExcel.vue";
Vue.component("importExcel", importExcel);


//eventBus
import eventBus from './assets/js/bus.js';
Vue.prototype.eventBus = eventBus;

// 请求
import axios from "axios";
Vue.prototype.axios = axios;

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;
import geoJson from "./assets/js/china.json";
echarts.registerMap("china", geoJson);

//表格导出
Vue.prototype.fExportDataEvent = async (table, qxName) => {
    //由于外部取不到table 所以需要通过函数调用用时传参 来找到该表格
    table.exportData({
        type: "csv"
    });
};
//线上环境去掉console.log
if (process.env.NODE_ENV === "production") {
    if (window) {
        window.console.log = function () { };
    }
}
Vue.config.productionTip = false;



new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js